import React, { useEffect, useRef, useState } from "react";
import PrototypeFrame from "components/brief/util/helpers/PrototypeFrame";

// The prototype is authored for a desktop screen, so it is rendered at that size and then
// scaled down to whatever room the card actually has, rather than reflowed.
const PreviewFrame = ({
  desktopViewport,
  documentUrl,
  frameId,
  frameRef,
  fullWidth,
  hasPrototype,
  isLoadError,
  padding,
}) => {

  const [scale, setScale] = useState(1);

  const previewContainerRef = useRef(null);

  useEffect(() => {
    const container = previewContainerRef.current;

    if (!container) {
      return () => {};
    }

    const updateScale = () => {
      const nextWidth = container.clientWidth;
      const nextHeight = container.clientHeight;

      if (!nextWidth || !nextHeight) {
        setScale(1);
        return;
      }

      const widthScale = nextWidth / desktopViewport.width;
      const heightScale = nextHeight / desktopViewport.height;
      const nextScale = Math.min(widthScale, heightScale, 1);

      setScale(nextScale);
    };

    updateScale();

    const observer = new ResizeObserver(() => {
      updateScale();
    });

    observer.observe(container);

    return () => {
      observer.disconnect();
    };
  }, [desktopViewport.height, desktopViewport.width]);

  return (
    <div
      ref={previewContainerRef}
      className="d-flex align-items-center justify-content-center flex-fill overflow-hidden"
      style={{ minHeight: 0, padding: fullWidth ? 0 : padding, backgroundColor: fullWidth ? "#ffffff" : "#f3f4f6" }}
    >
      <PrototypeFrame
        className="overflow-hidden"
        documentUrl={documentUrl}
        frameId={frameId}
        frameRef={frameRef}
        hasPrototype={hasPrototype}
        isLoadError={isLoadError}
        style={fullWidth ? {
          width: "100%",
          height: "100%",
          minWidth: 0,
          minHeight: 0,
        } : {
          width: `${desktopViewport.width * scale}px`,
          height: `${desktopViewport.height * scale}px`,
          minWidth: 0,
          minHeight: 0,
          borderRadius: "16px",
          border: "1px solid #d7dee7",
          boxShadow: "0 20px 40px rgba(15, 23, 42, 0.16)",
        }}
      />
    </div>
  );

};

export default PreviewFrame;
